import { useEffect } from "react";
import { useAuth, usePost } from "@onefront/react-sdk";
import { buildHeaders } from "../../../common-utils/buildHeaders";
import { DocumentsProps } from "../../types";
import { useClientInformationStore } from "../../../store/useClientInformationStore";
import { useFilters } from "../useFilters";
import DataFilter from "../../../document-page/components/table-headers/DataFilterTableHeader";

export function useGetDocuments({
  workspaceId,
  searchTerm,
  pageNumber,
  pageSize,
  sort = "LATEST_UPLOADS",
  readByAccountant,
  readByCompany,
  urgentDocs,
  isUrgent,
  onlyVisibleToMe,
  dateFilters,
  isFavourite,
  filterPerYear = "",
  dateType = "UPLOAD",
  tags,
  microCategory,
  macroCategory,
  selectedCategories = {},
  invoiceNumber,
  checkIfUploaded,
  hasMore,
}: DocumentsProps) {
  const authData = useAuth();
  const { selectedTenant: currentCompany } = useClientInformationStore();
  const [filters] = useFilters();
  const clientId = currentCompany?.itemId;
  if (macroCategory !== "") {
    selectedCategories.macrocategory = macroCategory;
  }
  if (invoiceNumber && invoiceNumber.length > 0) {
    selectedCategories.numeroFattura = invoiceNumber;
  } else {
    delete selectedCategories.numeroFattura;
  }

  // console.log(dateFilters, filters)

  const { data, loading, hasLoaded, fetch, error } = usePost(
    `documentsApi://api/v1/documents/search?`,
    {
      workspaceId,
      fullTextSearch: searchTerm,
      pageNumber,
      pageSize,
      sort,
      readByAccountant,
      readByCompany,
      isUrgent,
      isFavourite,
      onlyVisibleToMe,
      filterPerYear,
      dateType,
      dateFilters,
      tags,
      microcategory: microCategory,
      aggregationsFilter: selectedCategories,
      // loggedItemId: clientId,
      hasMore,
    },
    {
      lazy: true,
      headers: buildHeaders({ authData }),
    }
  );


  useEffect(() => {
    if ((hasMore && workspaceId) || checkIfUploaded || pageNumber) {
      fetch();
    }
  }, [
    searchTerm,
    workspaceId,
    sort,
    readByAccountant,
    readByCompany,
    urgentDocs,
    isFavourite,
    isUrgent,
    pageSize,
    filterPerYear,
    microCategory,
    dateType,
    dateFilters, //rerender 1 more
    tags, //rerender 1 more
    onlyVisibleToMe,
    pageNumber,
    selectedCategories,
    invoiceNumber,
    checkIfUploaded,
    hasMore,
  ]);

  return { data, loading, hasLoaded, fetch, error };
}
